// ConfirmStep.js
import React, { useContext, useState } from "react";
import { useMutation, gql } from "@apollo/client";
import { Button, Spinner } from "react-bootstrap";
import moment from "moment";
import { useTable } from "react-table";
import { UploadDataContext } from "./UploadDataContext";
import { excelDateToJSDate, notify } from "../../generic";
import { INSERT_UPLOAD_DATA } from "../../../api/queries/uploadData.mutations";
import { graphql } from "react-apollo";
import { getComptes } from "../../../api/queries/comptes.queries";
import { useAuthState } from "../../Context";
import { useNavigate } from "react-router-dom";

const ConfirmStep = ({ insertUploadData }) => {
  const navigate = useNavigate();
  const authContext = useAuthState(); //r
  const { userDetails = {} } = authContext;
  const { id: utilisateurId, login, email, token } = userDetails;

  const [loading, setLoading] = useState(false);
  if (!utilisateurId) return;
  const { prevStep, mappedData, selectedDataSource } = useContext(
    UploadDataContext
  );

  const data = React.useMemo(() => mappedData, [mappedData]);

  const handleImport = () => {
    setLoading(true);
    insertUploadData({
      variables: { utilisateurId, dataSourceId: selectedDataSource.value, data }
    })
      .then(({ data }) => {
        const { type, message, details } = data.insertUploadData;

        if (type === "success") {
          notify("success", "Import des données réussi");
          navigate(`/transactions/${selectedDataSource.value}`);
        } else {
          notify("error", message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date", // Assurez-vous que la clé est correctement mappée,
        Cell: ({ value }) =>
          typeof value === "number"
            ? moment(excelDateToJSDate(value)).format("D/M/YYYY")
            : value
      },
      {
        Header: "Libellé de transaction",
        accessor: "libelle" // Assurez-vous que la clé est correctement mappée
      },
      {
        Header: "Montant TTC",
        accessor: "montantTTC" // Assurez-vous que la clé est correctement mappée
      },
      {
        Header: "Montant HT",
        accessor: "montantHT" // Assurez-vous que la clé est correctement mappée
      }
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({ columns, data });

  return (
    <div>
      <h3>Étape 3 : Confirm Step</h3>
      <table {...getTableProps()} className="md">
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.slice(0, 5).map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      <button onClick={prevStep}>Étape précédente</button>
      <Button className="right" onClick={handleImport} disabled={loading}>
        {loading ? <Spinner animation="border" /> : "Importer"}
      </Button>
    </div>
  );
};

export default graphql(INSERT_UPLOAD_DATA, {
  name: "insertUploadData"
})(ConfirmStep);
